import { render, staticRenderFns } from "./TransactionMatching.vue?vue&type=template&id=6b27c82d&scoped=true"
import script from "./TransactionMatching.vue?vue&type=script&lang=js"
export * from "./TransactionMatching.vue?vue&type=script&lang=js"
import style0 from "./TransactionMatching.vue?vue&type=style&index=0&id=6b27c82d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27c82d",
  null
  
)

export default component.exports